<div class="kpi-grid">
  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-total">
        <i class="pi pi-briefcase"></i>
      </span>
      <span>Total Open</span>
    </div>
    <div class="kpi-value">{{ totalOpen }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-quick-wins">
        <i class="pi pi-bolt"></i>
      </span>
      <span>Quick Wins</span>
    </div>
    <div class="kpi-value">{{ quickWins }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-content-gaps">
        <i class="pi pi-file-edit"></i>
      </span>
      <span>Content Gaps</span>
    </div>
    <div class="kpi-value">{{ contentGaps }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-technical">
        <i class="pi pi-cog"></i>
      </span>
      <span>Technical Fixes</span>
    </div>
    <div class="kpi-value">{{ technicalFixes }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-local">
        <i class="pi pi-map-marker"></i>
      </span>
      <span>Local SEO</span>
    </div>
    <div class="kpi-value">{{ localSeo }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-competitors">
        <i class="pi pi-star"></i>
      </span>
      <span>Reviews</span>
    </div>
    <div class="kpi-value">{{ reviewSignals }}</div>
  </div>

  <div class="analytics-card kpi-card">
    <div class="kpi-header">
      <span class="kpi-icon icon-competitors">
        <i class="pi pi-users"></i>
      </span>
      <span>Competitor Gaps</span>
    </div>
    <div class="kpi-value">{{ competitorGaps }}</div>
  </div>
</div>
